var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { UnavailableShiftTranslationKeys } from '../ShiftFilters/UnavailableShiftFilter';
import { useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
export var useFilterCount = function (_a) {
    var filters = _a.filters;
    var filterCount = 0;
    var features = useAssociateContext().features;
    var filterValues = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (features.canFilterJobTypesOnFindShiftPage
        ? Object.values(filters.jobType)
        : []), true), Object.values(filters.location), true), Object.values(filters.shiftType), true), Object.entries(filters.unavailable)
        .filter(function (unavailableFilter) {
        return unavailableFilter[0] !=
            UnavailableShiftTranslationKeys.SHOW_ALL_UNAVAILABLE;
    })
        .map(function (unavailableFilter) {
        return unavailableFilter[1];
    }), true);
    for (var _i = 0, filterValues_1 = filterValues; _i < filterValues_1.length; _i++) {
        var filterValue = filterValues_1[_i];
        if (filterValue) {
            filterCount++;
        }
    }
    if (!!filters.shiftTime.startTime) {
        filterCount++;
    }
    if (!!filters.shiftTime.endTime) {
        filterCount++;
    }
    return filterCount;
};
